export { timeout } from './dev-utils';

export const generateRandomId = () =>
  Math.random()
    .toString(36)
    .substring(2);

// Capitalizes all the words and replaces some characters in the string to create a nicer looking title.
// eg. 'man from the boondocks' => 'Man From The Boondocks'
const titleize = (str) =>
  str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );

export const displayName = (
  { firstName = '', lastName = '' },
  options = { forceAnonymize: false, maxLength: 100 }
) => {
  const { maxLength, forceAnonymize } = options;
  const fullName = `${firstName} ${lastName}`;

  if (forceAnonymize || fullName.length > maxLength) {
    if (firstName.length > maxLength - 3) {
      return `${titleize(
        firstName.substring(0, maxLength - 4)
      )}... ${lastName.charAt(0).toUpperCase()}.`;
    }
    return `${titleize(firstName)} ${lastName.charAt(0).toUpperCase()}.`;
  }
  return fullName.trim();
};

export const isMobile = () => window.navigator.userAgent.includes('Mobile');

export const dateYearsAgo = (years) => {
  const d = new Date(new Date().toDateString());
  d.setFullYear(d.getFullYear() - years);
  return d;
};

export default {
  displayName,
  generateRandomId,
  isMobile,
  dateYearsAgo
};
